module.exports = __webpack_public_path__ + "static/1-ee996586beed39355c272a08ff1b1acd.jpg";